module.exports = __webpack_public_path__ + "static/media/screens.48925959.svg";